import { render, staticRenderFns } from "./baseHouse.vue?vue&type=template&id=6909fd00&scoped=true&"
import script from "./baseHouse.vue?vue&type=script&lang=js&"
export * from "./baseHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909fd00",
  null
  
)

export default component.exports